import { render } from "./PasswordChangePage.vue?vue&type=template&id=e22d6814"
import script from "./PasswordChangePage.vue?vue&type=script&lang=js"
export * from "./PasswordChangePage.vue?vue&type=script&lang=js"
script.render = render

export default script